import { baselineToPx } from '@scp/ui-shared/theme/utils';
export var COLUMN_SIZE = {
  SIDE_NAV: baselineToPx(50),
  LEFT: baselineToPx(91),
  RIGHT: baselineToPx(90),
  MIN_WIDTH_LEFT: baselineToPx(50)
};
export var MAIN_CONTENT_ID = 'main-content';
export var LAYOUT_Z_INDEX_MAP = {
  NAVIGATION: 2,
  HEADER_SHADOW: 1,
  REAL_HEADER: 2 // real header should be over shadow

};
export var TEXT = {
  SKIP_LINK: 'Skip to main content'
};
export var RESPONSIVE_NAV_SIZE = {
  WIDTH_PERCENTAGE: 88,
  MAX_WIDTH: baselineToPx(89),
  MIN_WIDTH: baselineToPx(70)
};